$shm_tests_benchmarks $mol_page
	results /
	display_title \
	title \Бенчмарки
	body <= body_rows /$mol_view
	Table $shm_tests_benchmark_table
		results <= results
	Empty $mol_paragraph
		title \Бенчмарки не записаны.
